'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _isDarkColor = require('./isDarkColor');
exports.default = _isDarkColor.isDarkColor;
module.exports = exports['default'];